angular.module('lsnBase.deprecated.models')
  .factory('IHestiaUserListResponseModel', ['LsnUserListResponseModelV1',
    function(LsnUserListResponseModelV1) {
      return LsnUserListResponseModelV1;
    }
  ]);